module.exports = __webpack_public_path__ + "static/media/logo-half-blue-white.1696f4bb.svg";